import { RiskLevel } from '../types';
import type { Case } from '../types';

/* リスクレベルの日本語ラベル。
 *
 * 同じ変換がコード中に6箇所あり、しかも一部の画面は enum の生値（High / Medium / Low）を
 * そのまま表示していた。作業員の確認画面とケース一覧のデスクトップ表がそれで、
 * 同じ一覧のモバイルカードだけが日本語という不一致まで起きていた。
 *
 * まずは英語が出ていた箇所をここに寄せる。残りの複製の統合は別タスクで行う
 * （ステータスと4Mのラベルも同様に分散している）。
 */
export function riskLabel(risk: RiskLevel | string | null | undefined): string {
  switch (risk) {
    case RiskLevel.HIGH:
      return '高';
    case RiskLevel.MEDIUM:
      return '中';
    case RiskLevel.LOW:
      return '低';
    default:
      // 想定外の値は握り潰さず、そのまま出して気づけるようにする
      return String(risk ?? '');
  }
}

/* 対応状況の日本語ラベル。
 *
 * 「対応済み」を正とする。理由:
 *  - 作業員向けの説明で「管理者の対応状況（未対応→対応中→対応済み）」と**約束している**
 *    （views/WorkerFlow.tsx / DemoExperience）。報告者への約束を破るのは避ける
 *  - ダッシュボードの見出しも「対応済みの割合」（App.tsx）
 *  - 未対応 / 対応中 / 対応済み で語彙が揃う。「解決済み」だけ別語彙で不揃いだった
 *
 * 以前は管理画面が「解決済み」、報告者の追跡画面が「対応済み」で、
 * **同じ案件を管理者と報告者が違う言葉で見ていた**。
 */
export function statusLabel(status: Case['status'] | string | null | undefined): string {
  switch (status) {
    case 'open':
      return '未対応';
    case 'in_progress':
      return '対応中';
    case 'resolved':
      return '対応済み';
    default:
      // 想定外の値は握り潰さず、そのまま出して気づけるようにする
      return String(status ?? '');
  }
}
